<template>
  <div class="c-aed-serviceProvider">
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--6">
          <span
            class="o-label"
            :title="serviceProviderTranslations.firstName || ''"
            >{{ serviceProviderTranslations.firstName || "" }}</span
          >
        </div>
        <div class="o-grid__item o-grid__item--6">
          <CallCenterAEDeditableInput
            :section="section"
            name="firstName"
            :value="(serviceProvider && serviceProvider.firstName) || ''"
          ></CallCenterAEDeditableInput>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--6">
          <span
            class="o-label"
            :title="serviceProviderTranslations.primaryPhoneNumber || ''"
            >{{ serviceProviderTranslations.primaryPhoneNumber || "" }}</span
          >
        </div>
        <div class="o-grid__item o-grid__item--6">
          <CallCenterAEDeditableInput
            :section="section"
            name="primaryPhoneNumber"
            type="tel"
            :value="
              (serviceProvider && serviceProvider.primaryPhoneNumber) || ''
            "
          ></CallCenterAEDeditableInput>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "c-aed-serviceProvider",
  data() {
    return {
      section: "serviceProvider",
      name: ""
    };
  },
  computed: {
    ...mapState("translations", {
      serviceProviderTranslations: "serviceProvider"
    }),
    ...mapGetters("aed", {
      serviceProvider: "serviceProvider"
    }),
    aedId() {
      return this.$store.state.aed.all.id;
    }
  }
};
</script>
<style lang="scss">
.c-aed-serviceProvider {
  .o-grid__item {
    display: flex;
    align-items: center;
  }
}
</style>
